import React, {useEffect, useState} from "react";
import leftPng from "../../../../content/images/left.png";
import $ from "jquery";
import * as GC from "../../../common/common";
import * as CommonFunctions from "./functions/commonFunctions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import CommonAttachments from "../../../common/attachment/Attachment";

const Detail = () => {
  useEffect(() => {
    $("#edit-button").click(function () {
      $("#editSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
      CommonFunctions.GetColumnProperties("edit");

      var model = {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: ["febe6c3b-abb3-4741-97c0-25fa510ec6aa"],
      };
      CommonFunctions.GetColumnPropertiesForModel(
        model,
        1,
        6,
        "edit",
        "algemeen-patroonvoorkeur-identification",
        window.$catalog_management_units_token
      );
      var model = {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [true],
            datatype: "BOOLEAN",
          },
        ],
        definitions: ["06c1ff31-8693-4838-a58f-d0c1c1f3bdd9"],
      };
      CommonFunctions.GetColumnPropertiesForModel(
        model,
        1,
        6,
        "edit",
        "algemeen-periodevoorkeur-identification",
        window.$catalog_management_units_token
      );

      GC.GetEntityList(
        process.env.REACT_APP_GROOTBOEK,
        1,
        500,
        CallBackFunctions.GrootboekCallbackForEditMaat,
        window.$catalog_management_units_token
      );
      GC.GetEntityList(
        process.env.REACT_APP_CATALOG_DISCIPLINE,
        1,
        500,
        CallBackFunctions.DisciplineCallbackForEditMaat,
        window.$catalog_management_units_token
      );
    });
    $(".back-page-link").click(function () {
      $("#tableSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
      $("#editSide").addClass("d-none");
    });

    $("#return-detail").click(function () {
      $("#detailSide").removeClass("d-none");
      $("#editSide").addClass("d-none");
    });

    // $(".back-page-link").click(function () {
    //   $("#tableSide").removeClass("d-none");
    //   $("#detailSide").addClass("d-none");
    //   $("#editSide").addClass("d-none");
    // });
    // $("#edit-button").click(function () {
    //   $("#editSide").removeClass("d-none");
    //   $("#detailSide").addClass("d-none");
    //   CommonFunctions.GetColumnProperties("edit");
    // });
    // $("#return-detail").click(function () {
    //   $("#detailSide").removeClass("d-none");
    //   $("#editSide").addClass("d-none");
    // });
  });

  const [media, setMedia] = useState(null);

  const handleModalAttachments = async () => {
    const spin = $("#cover-spin");
    spin.show(0);
    let result = await omnimap.GetMediaListAction(
        { path: "" },
        window.$catalog_measures_selectedRow.identification,
        window.$catalog_management_units_token
    );
    await setMedia(result);
    spin.hide(0);

    $("#wp-catalogus-attachments").modal("show");
  };

  return (
    <div id="detailSide" className="d-none">
      <div className="detail-title">Maatregelen in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
            Maatregelen
          </a>
        </div>
        <div className="float-right mt-0">
          <a id="edit-button" className="button bewerken">
            Bewerken
          </a>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Naam</div>
            <div className="box-title-2-active" id="naam" />
            <span className="tooltiptext detail" id="naam-tooltip"></span>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Code</div>
            <div className="box-title-2" id="code" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Bestekspost</div>
            <div className="box-title-2" id="bestekspost" />
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">RAW Hoofdcode</div>
            <div className="box-title-2" id="raw-hoofdcode" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">RAW Deficode</div>
            <div className="box-title-2" id="raw-deficode" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Eenheidsprijs</div>
            <div className="box-title-2" id="eenheidsprijs" />
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Eenheid</div>
            <div className="box-title-2" id="eenheid" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Percentage</div>
            <div className="box-title-2" id="percentage" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Kwaliteit</div>
            <div className="box-title-2" id="kwaliteit" />
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Omschrijving</div>
            <div className="box-title-2" id="omschrijving" />
            <span
              className="tooltiptext detail"
              id="omschrijving-tooltip"
            ></span>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Periode voorkeur</div>
            <div className="box-title-2" id="periode-voorkeur" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Patroon voorkeur</div>
            <div className="box-title-2" id="patroon-voorkeur" />
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Grootboek nummer</div>
            <div className="box-title-2" id="grootboek-nummer" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Discipline</div>
            <div className="box-title-2" id="discipline" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">BTW percentage</div>
            <div className="box-title-2" id="btw-percentage" />
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Actief</div>
            <label className="switch">
              <input id="maatregelen_active" type="checkbox" disabled />
              <span className="slider-checkbox round" />
            </label>
          </div>
        </div>
        <div className="col-lg-2 text-center">
          <div className="box-detail">
            <div className="box-title-1">Bijlage(n)</div>
            <a role="button" onClick={() => handleModalAttachments()}>
              <div className="box-title-2 bijlage-ico" id="d-bijlage" />
            </a>
          </div>
        </div>
      </div>

      <CommonAttachments
          media={media}
          setMedia={setMedia}
          rowId={window.$catalog_measures_selectedRow.identification}
          contextToReload={window.$catalog_measures_context}
      />
    </div>
  );
};

export default Detail;
